module.exports = __webpack_public_path__ + "static/media/Guinea Bissau.8d57020d.png";